<template>
    <multiselect
            class="compliance-type-select py-1 px-3"
            :options="complianceTypes.options"
            v-model="complianceTypeSelected"
            :hide-selected="false"
            :preselectFirst="true"
            :showLabels="false"
            :group-select="false"
            selectLabel=""
            placeholder=""
            tagPlaceholder=" "
            deselectLabel=""
            :searchable="false"
    >
        <template #caret="{ toggle }">
            <caret-icon
                    @mousedown.prevent.stop="toggle"
                    :solid="true"
                    :hide="complianceTypes.options.length === 0"
            ></caret-icon>
        </template>
        <template slot="singleLabel" slot-scope="props">
            <b-img :src="getIcon(props.option.assessmentTypeId)" width="16"></b-img>
            <span class="option__desc">
                    <span class="option__title">{{ props.option.assessmentType }}</span>
                </span>
        </template>
        <template slot="option" slot-scope="props">
            <b-img :src="getIcon(props.option.assessmentTypeId)" width="16"></b-img>
            <div class="option__desc">
                <span class="option__title">{{ props.option.assessmentType }}</span>
            </div>
        </template>
    </multiselect>
</template>

<script>
import AssessmentType from '@/services/Assessment/AssessmentType';
import { mapGetters, mapActions } from 'vuex';
import IconFire from '@/assets/images/compliance-icons/fire.svg';
import IconLegion from '@/assets/images/compliance-icons/legion.svg';
import IconAsbes from '@/assets/images/compliance-icons/asbes.svg';
import IconElec from '@/assets/images/compliance-icons/elec.svg';
import IconStock from '@/assets/images/compliance-icons/stock.svg';
import IconGas from '@/assets/images/compliance-icons/gas.svg';

export default {
  data() {
    return {
      complianceTypes: {
        options: [],
        icons: {
          2: IconFire,
          3: IconLegion,
          4: IconAsbes,
          5: IconElec,
          6: IconStock,
          7: IconGas,
        },
      },
      assetInspectionTypeId: 14,
    };
  },

  computed: {
    ...mapGetters(['complianceTypeId']),
    complianceTypeSelected: {
      get() {
        return this
          .complianceTypes
          .options
          .find(item => item.assessmentTypeId === this.complianceTypeId);
      },
      set(valueOptionObject) {
        const { assessmentTypeId } = valueOptionObject;
        this.setComplianceType(assessmentTypeId);
      },
    },
  },
  async mounted() {
    await this.getComplianceTypes();

    // Set the first item as the default if not already set
    if (!this.$store.getters.complianceTypeId && this.complianceTypes.options.length > 0) {
      this.setComplianceType(this.complianceTypes.options[0].assessmentTypeId);
    }
  },
  methods: {
    ...mapActions(['setComplianceType']),
    getIcon(complianceTypeId) {
      return this.complianceTypes.icons[complianceTypeId];
    },
    async getComplianceTypes() {
      const { data } = await AssessmentType.list({ parentTypeId: 0 });
      this.complianceTypes.options = data
        .data
        .filter(type => type.assessmentTypeId !== this.assetInspectionTypeId);
    },
  },
};
</script>

<style lang="scss">
    .compliance-type-select {
        margin-right: 5px;
        height: 33px;
        min-height: 33px;

        .multiselect_ {
            &_tags {
                border: none;
                background-color: unset;
                font-weight: bold;
                padding-left: 0;
                padding-top: 0;
                min-height: 28px;
                padding-right: 15px;
                min-width: 75px;

                .option__desc {
                    margin-left: 8px;
                }
            }

            &_single {
                padding: 0;
                margin: 0;
                background-color: unset;

                .option__title {
                    line-height: 34px;
                    padding-top: 0.25rem;
                    padding-bottom: 0.25rem;
                }
            }

            &_option {
              &:hover {
                background: #F7F9FA;
              }
              &--highlight {
                  background: $white;
                  color: $black;
              }
            }

            &_caret {
                top: 8px;
                right: 0;
            }

            &_content-wrapper {
                top: 42px;
                max-height: fit-content;
                padding: 0.5rem 0;
                margin: 0.125rem 0 0;
                font-size: 1rem;
                color: #4E738A;
                text-align: left;
                list-style: none;
                background-color: #ffffff;
                background-clip: padding-box;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 0.25rem;

                .option__desc {
                    display: inline-block;
                    margin-left: 10px;
                }
            }
        }
    }

    .spacer {
        position: relative;
        top: 13px;
        height: 15px;
        width: 2px;
        margin: 0 22px;
        background: #000;
    }

    @media screen and (max-width: 767px) {
      .compliance-type-select {
        max-width: 40px;
      }
    }

    @media screen and (max-width: 1024px) {
        .compliance-type-select {
            .multiselect_ {
                &_tags {
                    height: 28px;
                    padding-right: 0;
                }

                &_single {
                    .option__desc {
                        .option__title {
                            display: none;
                        }
                    }
                }

                &_caret {
                    left: 50px;
                }

                &_content-wrapper {
                    top: 39px;
                }
            }
        }

        .spacer {
            margin: 0;
        }

        .sub-nav /deep/ {
            .nav-items {
                max-width: 90vw !important;
                width: 100%;

                &.has-actions {
                    max-width: calc(82vw - 105px) !important;
                }
            }
        }
    }
</style>
